<div class="switch">
  @for (item of _choices; track item; let isFirst = $first) {
    <div>
      <input
        name="label"
        id="{{ item.id }}_{{ hash }}"
        type="radio"
        (change)="handleChange($event)"
      />
      <label #labels for="{{ item.id }}_{{ hash }}" class="switch__label">{{
        item.label
      }}</label>
    </div>
  }

  @if (selected) {
    <div
      #switchIndicator
      class="switch__indicator"
      [style.width]="selected.offsetWidth + 'px'"
      [style.transform]="
        'translateX(' + selected.getBoundingClientRect().left + 'px)'
      "
    ></div>
  }
</div>
